import { Chip, Stack } from "@mui/material";
import * as React from "react";
import PublishIcon from "@mui/icons-material/Publish";
import { FileUpload, FileUploadOutlined } from "@mui/icons-material";

export type TableCellRatingRequestsProps = {
  data: number;
};

const TableCellRatingRequests: React.FC<TableCellRatingRequestsProps> = ({ data }) => {
  return (
    <>
      {data ? (
        <Stack direction="row" sx={{ flexWrap: "wrap", gap: 0.5, my: 1 }}>
          <Chip label={data} icon={<FileUploadOutlined />} sx={{ mr: 0.5 }} />
        </Stack>
      ) : (
        <Chip label={"-"} size="small" sx={{ mr: 0.5 }} />
      )}
    </>
  );
};

export default TableCellRatingRequests;
